import { render, staticRenderFns } from "./formProductSharing.vue?vue&type=template&id=31ca5cb0&scoped=true&"
import script from "./formProductSharing.vue?vue&type=script&lang=js&"
export * from "./formProductSharing.vue?vue&type=script&lang=js&"
import style0 from "./formProductSharing.vue?vue&type=style&index=0&id=31ca5cb0&scoped=true&lang=css&"
import style1 from "./formProductSharing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca5cb0",
  null
  
)

export default component.exports